export default [
  {
    path: "/protocolsUser", // 平台用户协议
    name: "protocolsUser",
    component: () =>
      import(/* webpackChunkName: "protocol" */ "../views/Protocols/User.vue"),
  },
  {
    path: "/protocolsRegister", // 平台用户注册隐私协议
    name: "protocolsRegister",
    component: () =>
      import(
        /* webpackChunkName: "protocol" */ "../views/Protocols/UserRegister.vue"
      ),
  },
  {
    path: "/protocolsEscape", // 免责条款
    name: "protocolsEscape",
    component: () =>
      import(
        /* webpackChunkName: "protocol" */ "../views/Protocols/Escape.vue"
      ),
  },
  {
    path: "/protocolsLabSettle", // 免责条款
    name: "protocolsLabSettle",
    component: () =>
      import(
        /* webpackChunkName: "protocol" */ "../views/Protocols/LabSettlement.vue"
      ),
  },
];
